import { useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import { useAppContainer } from "../Main/AppContainerContext";
import Button from "../Buttons/Button";
import PushableContainer from "./PushableContainer";

const SidePanel = ({ isOpen = true, ...props }) => {
  const { onRequestClose, children } = props;
  const t = useFormatMessage();
  const closeLabel = t(intlMessages.overlay);
  const appContainer = useAppContainer();

  const overlayRef = useRef();

  const handleOverlayClick = useCallback(
    e => {
      if (e.target === overlayRef.current) {
        onRequestClose(e);
      }
    },
    [onRequestClose]
  );

  if (!isOpen) return null;

  return createPortal(
    <div className="side-panel-overlay" ref={overlayRef} onClick={handleOverlayClick}>
      <div className="side-panel bg-primary">
        <PushableContainer>
          <div className="position-relative">
            <Button
              type="button"
              className="modal-close"
              onClick={onRequestClose}
              iconClassName="icon-close"
              screenReaderLabel={closeLabel}
            />

            {children}
          </div>
        </PushableContainer>
      </div>
    </div>,
    appContainer
  );
};

export default SidePanel;

const intlMessages = defineMessages({
  overlay: {
    id: "overlay.closeOverlay",
    defaultMessage: "Fermer le panneau"
  }
});
